var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"icon-row__item"},[_c('button',{staticClass:"icon-row__button",style:(_vm.buttonBg),on:{"click":function($event){_vm.$emit('buttonClick', _vm.id)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }